import * as React from 'react';

import { inject } from 'mobx-react';
import { observer } from 'mobx-react-lite';

import { ECommonCounters, ELocalStorageMobile } from '@enums';

import { UiStore } from '@stores';

import { Api } from '@api';

import { getConfig } from '@base/constants';
import { EStore } from '@base/enums';
import {
	counters,
	getDisplayMode,
	getFromLocalStorage,
	Log,
	removeFromLocalStorage,
	setToLocalStorage,
} from '@base/utils';
import { getUserAgentInfo } from '@base/utils/getUserAgentInfo';

import { ActionPanel } from '@ui';

import { IconMyLogo } from '@icons';

import { IUser } from '@interfaces';

import * as s from './InstallPwaBubble.scss';

export interface IInstallPwaPanelProps {
	uiStore?: UiStore;
	currentUserStore?: IUser;
}

export const InstallPwaBubble: React.FC<IInstallPwaPanelProps> = inject(EStore.UI)(observer(
	({ uiStore }: IInstallPwaPanelProps) => {
		const [isInstallBtnVisible, setInstallBtnVisibility] = React.useState(false);
		const [installText, setInstallText] = React.useState('');
		const installApp = async () => {
			try {
				await Api.pwa.install({
					afterAcceptInstallCallback: () => {
						uiStore.toggleInstallButton(false);
						counters.sendRB(ECommonCounters.PWA_INSTALL_CLICK);
					},
				});
			} catch (err) {
				Log.error(`Can't install app: ${err}`);
			}
		};
		const closePanel = () => {
			uiStore.toggleInstallButton(false);
			setToLocalStorage(ELocalStorageMobile.HIDE_PWA_INSTALL_WEB_MOBILE, Date.now().toString());
		};
		const isHiddenExpired = (() => {
			const hidingDuration = getConfig().installButtonHideDuration;
			const storedTime = !IS_SSR ? getFromLocalStorage(ELocalStorageMobile.HIDE_PWA_INSTALL_WEB_MOBILE) : 0;
			const currentDurationOfHiding = Date.now() - Number(storedTime);

			return currentDurationOfHiding > hidingDuration;
		})();

		// видимость блока
		React.useEffect(() => {
			let isVisible;

			if (isHiddenExpired) {
				const {
					isShowInstallBtn,
					isPwaEnabled,
				} = getConfig();
				const isBrowser = IS_SSR ? true : getDisplayMode() === 'browser';

				isVisible = uiStore.isInstallButtonVisible && isShowInstallBtn && isBrowser && isPwaEnabled;
				removeFromLocalStorage(ELocalStorageMobile.HIDE_PWA_INSTALL_WEB_MOBILE);
			} else {
				isVisible = false;
			}

			setInstallBtnVisibility(isVisible);
		}, [isHiddenExpired, uiStore.isInstallButtonVisible, IS_SSR]);

		// в зависимости от user agent ставим текст в кнопке
		React.useEffect(() => {
			let title = getConfig().installPwaPanelText.desktop;

			switch (true) {
				case getUserAgentInfo().isTablet:
					title = getConfig().installPwaPanelText.tablet;
					break;
				case getUserAgentInfo().isMobile:
					title = getConfig().installPwaPanelText.mobile;
					break;
			}

			setInstallText(title);
		}, []);

		return (
			<>
				{ isInstallBtnVisible && <ActionPanel
					onActionClick={installApp}
					className={s.block}
					iconClassName={s.icon}
					text={installText}
					icon={IconMyLogo}
					onClose={closePanel}
				/> }
			</>
		);
	},
));
